import api from 'config/axiosConfig';

export const getDetails = id => {
  return api.get(`api/methods/${id}/details`);
};
